import { Controller } from "@hotwired/stimulus"

// Client-side search filter for the "Browse all" section of the shared
// Common::SubjectAssetPickerComponent. Modeled after bg_picker_search.
// Hides cards whose haystack (slug + display_name + category +
// spoken_phrase_text + spoken_language, lowercased, joined) doesn't
// contain the input term. When every card in a category group is
// hidden, the group heading hides too. When zero cards across the whole
// browse section match, an "empty" message is surfaced via a data-attr
// on the root that the CSS reads.
//
// Targets:
//   input         — the <input type="search">
//   card          — every <label class="subjpicker__card"> in the
//                   Browse-all section
//   categoryGroup — the <div.subjpicker__category> wrapper around each
//                   category's grid (so we can hide empty groups)
export default class extends Controller {
  static targets = ["input", "card", "categoryGroup"]

  filter() {
    const term = (this.inputTarget.value || "").trim().toLowerCase()
    let totalVisible = 0

    this.cardTargets.forEach((card) => {
      const haystack = card.dataset.subjpickerHaystack || ""
      const visible = !term || haystack.includes(term)
      card.hidden = !visible
      if (visible) totalVisible += 1
    })

    this.categoryGroupTargets.forEach((group) => {
      const anyVisible = Array.from(
        group.querySelectorAll('[data-subject-picker-search-target="card"]')
      ).some((c) => !c.hidden)
      group.hidden = !anyVisible
    })

    this.element.dataset.subjectPickerSearchEmpty = totalVisible === 0 ? "true" : "false"
  }
}
